import React from 'react';
import { Localizer } from 'services/Localizer';
import Modal from 'shared/components/Modal';
import Pagination from 'shared/components/Pagination';
import { toKebabCase } from 'util/StringUtil';
import { useShoppingListLoader } from '../my-account/shopping-lists/useShoppingListLoader';

interface ProductAddToListModalProps {
	/**
	 * State for whether the modal is open or not.
	 *
	 * @type {boolean}
	 * @memberof ProductAddToListModalProps
	 */
	openListModal: boolean;

	/**
	 * Method for changing the open state of the modal.
	 *
	 * @memberof ProductAddToListModalProps
	 */
	setOpenListModal: (isOpen: boolean) => void;

	/**
	 * Method for setting the 'add new list' modal open state.
	 *
	 * @memberof ProductAddToListModalProps
	 */
	setModalOpen: (open: boolean) => void;

	/**
	 * Method that is called when a list is selected.
	 *
	 * @memberof ProductAddToListModalProps
	 */
	handleAddToList: (shoppingListId: any) => Promise<void>;
}

const resultsPageSize = 15;

/**
 * Component that houses the modal and the list results.
 *
 * @export
 * @param {ProductAddToListModalProps} props
 * @returns
 */
export default function ProductAddToListModal(props: ProductAddToListModalProps) {
	const { openListModal, setModalOpen, setOpenListModal, handleAddToList } = props;

	const { results, goToNextPage, goToPage, goToPreviousPage } = useShoppingListLoader({
		initialPageSize: resultsPageSize,
	});

	return (
		<Modal
			isOpen={openListModal}
			renderTitle={() => Localizer('ShoppingLists')}
			renderActions={() => (
				<div className="roc-modal__actions roc-modal__actions--wrap">
					<div className="roc-modal__actions-item roc-modal__actions-item--centered roc-modal__actions-item--full-width">
						<button
							className="roc-btn roc-modal__actions-item-btn"
							data-testid="add-new-shopping-list"
							onClick={() => (setModalOpen(true), setOpenListModal(false))}
						>
							+ {Localizer('AddNewShoppingList')}
						</button>
					</div>

					{results && results.results && results.pagination.totalPages > 1 ? (
						<div className="roc-modal__actions-item roc-modal__actions-item--centered roc-modal__actions-item--full-width">
							<Pagination
								flush
								pagination={results.pagination}
								goToNextPage={goToNextPage}
								goToPage={goToPage}
								goToPreviousPage={goToPreviousPage}
							/>
						</div>
					) : null}
				</div>
			)}
			closeModal={() => setOpenListModal(false)}
		>
			<ul className="roc-utlity-nav__menu" data-testid="shopping-lists-list">
				{results &&
					results.results &&
					results.results.map((shoppingList, index) => {
						return (
							<li className="roc-utlity-nav__menu-item" key={index}>
								<button
									className="roc-utlity-nav__menu-item-link"
									data-testid={`shopping-list-${toKebabCase(shoppingList.name)}-${index}`}
									onClick={() => handleAddToList(shoppingList.id)}
								>
									{shoppingList.name}
								</button>
							</li>
						);
					})}
			</ul>
		</Modal>
	);
}
